import styled from "styled-components";
import { colors } from "..";

var fontSizes = {
  xxs: "0.6em",
  xs: "0.75em", // 12px
  small: "0.875em", // 14px
  normal: "1em", // 16px
  large: "1.2em",
  xl: "1.5em",
  xxl: "2em"
};

var notificationTypes = {
  info: { bg: "#E7E9F5", accent: colors.coreNavy },
  error: { bg: "#fbe9e7", accent: "#E30425" },
  warning: { bg: "#FFF8E1", accent: "#FFC021" }
};

var Notification = styled.div.withConfig({
  displayName: "Notification",
  componentId: "sc-16ulgdo-0"
})(["position:relative;padding:1rem;padding-left:2.5rem;font-size:", ";background-color:", ";border-radius:8px;line-height:1.45em;&::before{content:\"\";display:block;position:absolute;left:1.25rem;top:1rem;bottom:1rem;width:4px;border-radius:4px;background-color:", ";}& + &{margin-top:1rem;}"], function (props) {
  return fontSizes[props.size];
}, function (props) {
  return notificationTypes[props.type].bg;
}, function (props) {
  return notificationTypes[props.type].accent;
});

Notification.defaultProps = {
  type: "error",
  size: "small"
};

export default Notification;